'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AddEvent = function AddEvent(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M6,18v-3H4v3H1v2h3v3h2v-3h3v-2H6z"
  }), React__default["default"].createElement("rect", {
    x: "12",
    y: "12",
    width: "5",
    height: "5"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    d: "M19,3h-1V1h-2v2H8V1H6v2H5C3.89,3,3.01,3.9,3.01,5l-0.005,8H5V8h14v11h-8v2h8c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z"
  })));
};

var AddEvent$1 = iconStyles()(AddEvent);

module.exports = AddEvent$1;
